import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'settings_json': 'String!'
};

export default gql(`
	mutation settings( ${ HelperGraphql.createFields( fields ) } ) {
	    settings( ${ HelperGraphql.createVariables( fields ) } ) {
	       name
	    }
	}
`);

